import React from 'react'
import GenericPullConfigListing from '../GenericPullConfigListing'
import ContrastSecurityCredentialsForm from './ContrastSecurityCredentialsForm'
import ContrastSecurityMappingForm from './ContrastSecurityMappingForm'

function ContrastSecurityConfigListing(props) {
    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={ContrastSecurityMappingForm}
            CredentialsForm={ContrastSecurityCredentialsForm}
            componentName="Application"
            componentKey="applicationName"
        />
    )
}

export default ContrastSecurityConfigListing
